export class Register {
  firstName: string;
  lastName: string;
  surName: string;
  role: string;
  email: string;
}
